import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountryDropdownComponent } from './country-dropdown.component';
import {InfiniteScrollModule} from "ngx-infinite-scroll";
import { ParameterService } from '../../utils/services/parameter.service';
import { ReactiveFormsModule } from '@angular/forms';
import {ImageLoaderModule} from '../image-loader/image-loader.module';

@NgModule({
  imports: [
    CommonModule,
    InfiniteScrollModule,
    ReactiveFormsModule,
    ImageLoaderModule
  ],
  declarations: [CountryDropdownComponent],
  exports: [CountryDropdownComponent]
})
export class CountryDropdownModule { }



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/shared/country-dropdown/country-dropdown.module.ts